import RequestSpin from "slotworks/state-machine/standard/states/request-spin";
import Contract from "slotworks/utils/contract";
import Sequence from "slotworks/utils/contracts/sequence";

export default class GameiomRequestSpin extends RequestSpin {

    public error() {
        // Let the wrapper take over
        gameWrapper.setIdle();

        super.error();
    }

    protected startSpinning() {
        return new Sequence([
            () => Contract.wrap(() => {
                gameWrapper.winningsUpdate(0);
                gameWrapper.setBusy();
            }),
            () => super.startSpinning()
        ]);
    }
}
